import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import banner from '../pics/banner.PNG';
import Select from 'react-select';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboard, Menu} from 'lucide-react';
import About from '../About/About';
import axios from 'axios';

class Pricelist extends React.Component {
    constructor(props) {
        super(props);
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            servicedate: new Date(),
            comments: '',
            loadweights: '',
            customername: '',
            customerid: '',
            address: '',
            totalamount: '0.00',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            gender: "",
            token: "",
            notes: '',
            role: "",
            weightlist: [],
            dryfoldprices: [],
            ironfoldonlyprices: [],
            washdryfoldprices: [],
            allservicesprices: [],
            washdryironprices: [],
            userid: '',
            userstatus: '',
            registrationdate: ''

        }
    }

    componentDidMount = async () => {
        //let strStat = '';
        // let strOrders = await getCustomerOrders(this.props.location.state.userid);

        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, gender: this.props.location.state.gender, allservicesprices: this.getWashDryFoldPriceList(),
                userstatus: this.props.location.state.userstatus, registrationdate: this.props.location.state.registrationdate
            })
            await this.getIronFoldOnlyPriceList();
            await this.getWashDryIronPriceList();
        }
    }

    getWashDryFoldPriceList = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry", "pricelist": "washdryfold" }
        }
      //  const url = "http://localhost/iwash-php/api/getPriceList.php";
        //const url = "https://testmembership.bktsystems.com/api/UAT_getPriceList.php";
        const url = "https://testmembership.bktsystems.com/api/getPriceList.php";
        const response = await axios.get(url, config);

        const washdryfoldlist = response.data.weightlist;
        const washdryfoldprice = JSON.parse(response.data.washdryfoldprice);

        try {
            // 2. Convert the text string into a real JavaScript array
            const parsedwashdryfoldlist = new Function(`return ${washdryfoldlist};`)();

            // 3. Save the actual array to your state
            this.setState({ weightlist: parsedwashdryfoldlist, washdryfoldprices: washdryfoldprice });
        } catch (error) {
            console.error("Failed to parse JSON string:", error);
            this.setState({ weightlist: [], washdryfoldprices: [] }); // Fallback to empty array if parsing fails
        }
        return response.data;
    }

    getIronFoldOnlyPriceList = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry", "pricelist": "ironfoldonly" }
        }
        //const url = "http://localhost/iwash-php/api/getPriceList.php";
        //const url = "https://testmembership.bktsystems.com/api/UAT_getPriceList.php";
        const url = "https://testmembership.bktsystems.com/api/getPriceList.php";
        const response = await axios.get(url, config);

        //const washdryfoldlist = response.data.weightlist;
        const ironfoldonlyprice = JSON.parse(response.data.ironfoldonlyprice);

        try {

            // 3. Save the actual array to your state
            this.setState({ ironfoldonlyprices: ironfoldonlyprice });
        } catch (error) {
            console.error("Failed to parse JSON string:", error);
            this.setState({ ironfoldonlyprices: [] }); // Fallback to empty array if parsing fails
        }
        return response.data;
    }

    getWashDryIronPriceList = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry", "pricelist": "washdryiron" }
        }
       // const url = "http://localhost/iwash-php/api/getPriceList.php";
       // const url = "https://testmembership.bktsystems.com/api/UAT_getPriceList.php";
       const url = "https://testmembership.bktsystems.com/api/getPriceList.php";
        const response = await axios.get(url, config);

        //const washdryfoldlist = response.data.weightlist;
        const washdryironprice = JSON.parse(response.data.washdryironprice);

        try {
            // 3. Save the actual array to your state
            this.setState({ washdryironprices: washdryironprice });
        } catch (error) {
            console.error("Failed to parse JSON string:", error);
            this.setState({ washdryironprices: [] }); // Fallback to empty array if parsing fails
        }
        return response.data;
    }

    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city, 
                    userid: this.props.location.state.userid, gender: this.props.location.state.gender, userstatus: this.props.location.state.userstatus, registrationdate: this.props.location.state.registrationdate
            }
        });
    }
    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    openLogOut = (e) => {
        this.handleLogOutOpen.current.handleLogOutOpen();
    }
    confirmLogout = () => {
        // Perform logout actions here (e.g., clearing tokens, redirecting)
        localStorage.removeItem("token");
        this.setState({ open: false });
        this.props.navigate('/', {
            state: {
            }
        });
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }
        return (
            <>
                <div style={{
                    height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px",
                    fontFamily:"lora"
                }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid white', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{
                            paddingTop: "10px", paddingBottom: "10px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold",
                            textShadow: "2px 2px 4px #000000"
                        }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />                                                   
                        </div>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "2vh" }}>
                        <span variant="primary" style={{
                             border: "none",
                            paddingTop: "2vh", height: "60px", paddingBottom: "1vh", display: "flex", width: "100%", borderRadius: "10px",
                        }} onClick={this.goBackToMenu}>
                            <span style={{
                                 textAlign: "center", fontStyle: "italic", color: "darkblue",
                                fontWeight: "bold", textShadow: "1px 1px 2px gray", fontSize: "18px"
                            }}><ArrowLeft color="darkblue" size={40} /> OUR PRICELIST</span>
                        </span>
                    </div>
                    {/* Second div for content */}
                    <div style={{ paddingTop: "0.5vh", paddingBottom: "1vh", borderRadius: "10px", display: "flex", gap: "1rm", width: "100%" }}>
                        <div style={{
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", padding: "10px",
                            display: "flex", flexDirection: "column", gap: "1vh", alignItems: "center", width: "100%"
                        }}>
                            <h4 style={{ textAlign: "center", color: "darkblue", fontWeight: "bold" }}>Iron & Fold Only</h4>
                            <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, gap: "1vh", width: "100%" }}>
                                {this.state.weightlist.map((weight, index) => (
                                    <div key={index} style={{
                                        display: "flex", justifyContent: "space-between", padding: "10px",
                                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9", borderRadius: "5px"
                                    }}>
                                        <span style={{ fontWeight: "bold", color: "#333" }}>{weight.value}</span>
                                        <span style={{ fontWeight: "bold", color: "darkblue" }}>R{this.state.ironfoldonlyprices[weight.value] ? this.state.ironfoldonlyprices[weight.value].toFixed(2) : "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* Second div for content */}
                    <div style={{ paddingTop: "0.5vh", paddingBottom: "1vh", borderRadius: "10px", display: "flex", gap: "1rm", width: "100%" }}>
                        <div style={{
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", padding: "10px",
                            display: "flex", flexDirection: "column", gap: "1vh", alignItems: "center", width: "100%"
                        }}>
                            <h4 style={{ textAlign: "center", color: "darkblue", fontWeight: "bold" }}>Wash - Dry & Fold</h4>
                            <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, gap: "1vh", width: "100%" }}>
                                {this.state.weightlist.map((weight, index) => (
                                    <div key={index} style={{
                                        display: "flex", justifyContent: "space-between", padding: "10px",
                                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9", borderRadius: "5px"
                                    }}>
                                        <span style={{ fontWeight: "bold", color: "#333" }}>{weight.value}</span>
                                        <span style={{ fontWeight: "bold", color: "darkblue" }}>R{this.state.washdryfoldprices[weight.value] ? this.state.washdryfoldprices[weight.value].toFixed(2) : "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* third div for content */}
                    <div style={{ paddingTop: "0.5vh", paddingBottom: "2px", borderRadius: "10px", display: "flex", gap: "1rm", width: "100%" }}>
                        <div style={{
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", padding: "10px",
                            display: "flex", flexDirection: "column", gap: "1vh", alignItems: "center", width: "100%"
                        }}>
                            <h4 style={{ textAlign: "center", color: "darkblue", fontWeight: "bold" }}>Wash - Dry & Iron</h4>
                            <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, gap: "1vh", width: "100%" }}>
                                {this.state.weightlist.map((weight, index) => (
                                    <div key={index} style={{
                                        display: "flex", justifyContent: "space-between", padding: "10px",
                                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9", borderRadius: "5px"
                                    }}>
                                        <span style={{ fontWeight: "bold", color: "#333" }}>{weight.value}</span>
                                        <span style={{ fontWeight: "bold", color: "darkblue" }}>R{this.state.washdryironprices[weight.value] ? this.state.washdryironprices[weight.value].toFixed(2) : "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* keep the footer at the bottom of the page */}
                    <div style={{ paddingTop: "1px", fontSize: "15px" }}>
                        <div style={{
                            marginTop: "2%", borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingBottom: "20px"
                        }}>
                            <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                            <div>
                                <Button style={{
                                    backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                    fontWeight: "bold", textDecoration: "underline"
                                }}
                                    onClick={this.openAbout}>About Us
                                </Button>
                                | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>
                            </div>
                        </div>
                        <div>
                            <About
                                ref={this.handleAboutOpen}
                                onAboutClose={this.onAboutClose}
                            />
                        </div>

                    </div>
                </div>
            </>
        )
    }
}

export default withNavigateHook(Pricelist);